import { createRoot } from 'react-dom/client';
import './Gui/components/style.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { themes } from './Gui/theme';
import HeartbeatManager from 'HeartbeatManager';
import App from 'App';
import AppBootstrap from './AppBootstrap';
import DemoAppBootstrap from './demo/DemoAppBootstrap';
import DemoSceneSwitcher from './demo/DemoSceneSwitcher';
import TestingHooks from './testing/TestingHooks';
import usePersistentStore from '@gui/store/persistent/persistentStore';
import { ReactNode, useEffect, useMemo } from 'react';
import { enableSentry } from 'sentry';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { getEnvStore } from './store/EnvStore';

const ThemeContainer = ({ children }: { children: ReactNode }) => {
    const mode = usePersistentStore((state) => state.global.settings.themeMode);
    const theme = useMemo(() => themes[mode], [mode]);
    useEffect(() => {
        document.body.dataset.theme = mode;
        return () => {
            delete document.body.dataset.theme;
        };
    }, [mode]);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline /> {/* injects reset + theme typography */}
            {children}
        </ThemeProvider>
    );
};

function NormalPage() {
    return (
        <AppBootstrap>
            {import.meta.env.MODE === 'test' && (
                <>
                    <TestingHooks />
                </>
            )}
            <HeartbeatManager>
                <App />
            </HeartbeatManager>
        </AppBootstrap>
    );
}

function DemoPage() {
    return (
        <DemoAppBootstrap>
            <App />
            <DemoSceneSwitcher />
        </DemoAppBootstrap>
    );
}

function RootPage() {
    return getEnvStore().env === 'demo' ? <DemoPage /> : <NormalPage />;
}

enableSentry();
const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
    <ThemeContainer>
        <BrowserRouter basename="/visualizer">
            <Routes>
                <Route path="/*" element={<RootPage />} />
            </Routes>
        </BrowserRouter>
    </ThemeContainer>
);
